import styled from 'styled-components';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__Wrapper",
  componentId: "cnhh1n-0"
})(["width:100%;display:", ";align-items:", ";margin-bottom:", ";"], function (props) {
  return props.table ? 'flex' : 'block';
}, function (props) {
  return props.table ? 'flex-start' : null;
}, function (_ref) {
  var marginBottom = _ref.marginBottom,
    theme = _ref.theme;
  return marginBottom ? theme.spacing.sp16 : null;
});
export var QuantityLabel = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__QuantityLabel",
  componentId: "cnhh1n-1"
})(["font-family:", ";font-size:", ";"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSize.ft20;
});
export var AddToCartButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__AddToCartButton",
  componentId: "cnhh1n-2"
})(["margin-bottom:", ";margin-right:", ";"], function (_ref4) {
  var table = _ref4.table,
    theme = _ref4.theme;
  return table ? null : theme.spacing.sp16;
}, function (_ref5) {
  var table = _ref5.table,
    theme = _ref5.theme;
  return table ? theme.spacing.sp8 : null;
});
export var AddToListButton = /*#__PURE__*/styled.div.withConfig({
  displayName: "style__AddToListButton",
  componentId: "cnhh1n-3"
})(["margin-bottom:", ";margin-right:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.spacing.sp0;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing.sp0;
});
export var Quantity = /*#__PURE__*/styled(AddToCartButton).withConfig({
  displayName: "style__Quantity",
  componentId: "cnhh1n-4"
})(["display:flex;justify-content:space-between;align-items:center;"]);
export var Message = /*#__PURE__*/styled.span.withConfig({
  displayName: "style__Message",
  componentId: "cnhh1n-5"
})(["color:", ";font-family:", ";font-size:", ";font-weight:", ";margin-bottom:", ";padding:", " 0;text-align:center;display:block;"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.border.alert;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fonts.fontFamily.primary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fonts.fontSize.ft16;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fonts.fontWeight.medium;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.spacing.sp12;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.spacing.sp4;
});